import { datadogRum } from '@datadog/browser-rum-slim';
import { CoreApplicationContext } from '@eventbrite/context-gen';
import { PlaceObject, Suggestions } from '@eventbrite/discover-utils';
import { EBEnvs, getCurrentEnv } from '@eventbrite/feature-detection';
import { middleware as analyticsMiddleware } from '@eventbrite/site-analytics';
import { StatsigOptions } from '@eventbrite/statsig';
import { $FixMe } from '@eventbrite/ts-utils';
import React, { FC } from 'react';
import { Provider } from 'react-redux';
import { StringifyQuery } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { useEffectOnce } from 'react-use';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { ConnectedBasePage } from '../../containers/ConnectedBasePage';
import reducer from '../../redux/reducers';
import { getInitialData } from '../../redux/reducers/utils';
import { FeatureFlags } from '../../types';
import { FooterLinksShape } from '../../types/index';

import '../app.scss';
import './BrowsePage.scss';
import { CityBrowseBaseScreenContainer } from './containers';

type BrowsePageProps = RouteComponentProps & {
    footerLinks: FooterLinksShape;
    app_version?: string;
    app_name: string;
    env: CoreApplicationContext['env'];
    buckets: any;
    locations?: {
        places: PlaceObject[];
    };
    featureFlags: FeatureFlags;

    suggestions: Suggestions;
    http_referer: StringifyQuery;
    trending_search_cities?: string[][];
    user: {
        isAuthenticated?: boolean;
        publicId?: string;
        email?: string;
        isStaff?: boolean;
    };
    request: {
        path: string;
        session_id: string;
    };
    category_article_mapping: $FixMe;
    options: StatsigOptions;
};
const BrowsePage: FC<BrowsePageProps> = (props) => {
    const initialState = getInitialData(props);
    const store = createStore(
        reducer,
        initialState,
        applyMiddleware(thunk, analyticsMiddleware(props)),
    );

    useEffectOnce(() => {
        if (getCurrentEnv(props) === EBEnvs.PROD) {
            datadogRum.onReady(() =>
                datadogRum.setGlobalContextProperty('view.sub_app', 'browse'),
            );
        }
    }, []);

    return (
        <Provider store={store}>
            <ConnectedBasePage {...props}>
                <div className="feed-browse-page">
                    {/* FIXME: fix mismatched types/props error https://eventbrite.atlassian.net/browse/EB-228487 */}
                    {/* eslint-disable-next-line */}
                    {/* @ts-ignore  */}
                    <CityBrowseBaseScreenContainer {...props} />
                </div>
            </ConnectedBasePage>
        </Provider>
    );
};

export default BrowsePage;
